import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

const Logo = forwardRef(
  (
    {
      disabledLink = false,
      logoText = 'SNT',
      variant = 'h6',
      fontWeight = 600,
      color = 'inherit',
      sx,
      ...other
    },
    ref
  ) => {
    const logoComponent = (
      <Typography
        ref={ref}
        variant={variant}
        component="div"
        color={color}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          fontWeight,
          cursor: 'pointer',
          width: '100%',
          ...sx,
        }}
        {...other}
      >
        {logoText}
      </Typography>
    );

    if (disabledLink) {
      return logoComponent;
    }

    return (
      <Link
        aria-label="Logo"
        component={RouterLink}
        href="/"
        sx={{ display: 'inline-flex', textDecoration: 'none' }}
      >
        {logoComponent}
      </Link>
    );
  }
);

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  logoText: PropTypes.string,
  variant: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  sx: PropTypes.object,
};

export default Logo;
